<template>
  <div class="navbar">
    <div>
      <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
      <template v-if="!isOnly">
        <NavToggle></NavToggle>
      </template>
    </div>
    <div v-if="!isOnly" class="right-menu flexBet">
      <el-dropdown v-if="subsidiaryDropLists && subsidiaryDropLists.length > 1" class="item mr-24" trigger="click">
        <div class="avatar-wrapper">
          <el-tooltip v-if="isSmallScreen" :content="selectedOrganization" placement="top" effect="light">
            <img src="@/assets/image/header-menu-icon.png" alt="" class="icon" />
          </el-tooltip>
          <template v-if="!isSmallScreen">
            <img src="@/assets/image/header-menu-icon.png" alt="" class="icon" />
            {{ selectedOrganization }}
            <img src="@/assets/image/switch.png" alt="" class="arrow" />
          </template>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in subsidiaryDropLists"
            :key="item.organizationId"
            :style="{ color: item.organizationName === selectedOrganization ? '#378ff4' : '#0f1428' }"
            @click.native="selectOrganization(item)"
          >
            <span>{{ item.organizationName }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="avatar-container right-menu-item hover-effect mr-24 item" trigger="click">
        <div class="avatar-wrapper">
          <el-tooltip v-if="isSmallScreen" content="帮助" placement="top" effect="light">
            <img src="@/assets/image/help.png" alt="" class="icon" />
          </el-tooltip>
          <template v-if="!isSmallScreen">
            <img src="@/assets/image/help.png" alt="" class="icon" />
            帮助
            <img src="@/assets/image/arrowDown.png" alt="" class="arrow" />
          </template>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in helpOpts" :key="index" @click.native="optionDetail(item.type)">
            <img :src="item.icon" alt="" style="width: 16px; height: 16px; vertical-align: text-bottom; margin-right: 8px" />
            <span style="color: #3d3d3d">{{ item.title }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div @click="goDetail" class="item mr-24 notice">
        <el-tooltip v-if="isSmallScreen" content="通知" placement="top" effect="light">
          <img src="@/assets/image/notice.png" alt="" class="icon" />
        </el-tooltip>
        <template v-if="!isSmallScreen">
          <img src="@/assets/image/notice.png" alt="" class="icon" />
          <span>通知</span>
          <div v-if="adminMessageTotal" class="notice-dot"></div>
        </template>
      </div>
      <el-dropdown class="avatar-container right-menu-item hover-effect item" trigger="click">
        <div class="avatar-wrapper">
          <el-tooltip v-if="isSmallScreen" content="我的" placement="top" effect="light">
            <img src="@/assets/image/user-icon.png" alt="" class="icon" />
          </el-tooltip>
          <template v-if="!isSmallScreen">
            <img src="@/assets/image/user-icon.png" alt="" class="icon" />
            {{ userName }}
            <img src="@/assets/image/arrowDown.png" alt="" class="arrow" />
          </template>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in userOpts" :key="index" @click.native="optionDetail(item.type)">
            <img :src="item.icon" alt="" style="width: 16px; height: 16px; vertical-align: text-bottom; margin-right: 8px" />
            <span style="color: #3d3d3d">{{ item.title }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <securityCenter ref="SecurityCenter" />
    <waitingApproval ref="WaitingApproval" />
    <initiateApproval ref="InitiateApproval" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import NavToggle from '@/components/NavToggle'
import securityCenter from './securityCenter'
import waitingApproval from './waitingApproval/index.vue'
import initiateApproval from './initiateApproval/initiateApproval'
import { setCurrentOrganizationId, getCurrentOrganizationId, setFirstCommunityId } from '@/utils/auth'
export default {
  inject: ['indexThis'],
  props: {
    adminMessageTotal: {
      type: Number,
      default: 0,
    },
    isOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Breadcrumb,
    Hamburger,
    NavToggle,
    initiateApproval,
    securityCenter,
    waitingApproval,
  },
  data() {
    return {
      helpOpts: [
        {
          title: '操作手册',
          icon: require('../../assets/image/operatingManual.png'),
          type: 2,
        },
        {
          title: '视频教程',
          icon: require('../../assets/image/videoTutorials.png'),
          type: 3,
        },
      ],
      userOpts: [
        {
          title: '发起审批',
          icon: require('../../assets/image/initiateApproval.png'),
          type: 6,
        },
        {
          title: '待我审批',
          icon: require('../../assets/image/waitingApproval.png'),
          type: 7,
        },
        {
          title: '导入导出记录',
          icon: require('../../assets/image/exportRecords.png'),
          type: 1,
        },
        {
          title: '安全中心',
          icon: require('../../assets/image/securityCenter.png'),
          type: 4,
        },
        {
          title: '退出登录',
          icon: require('../../assets/image/logout.png'),
          type: 5,
        },
      ],
      selectedOrganization: '',
      isSmallScreen: false,
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar']),
    userName() {
      return this.$store.getters.name
    },
  },
  watch: {
    subsidiaryDropLists() {
      this.initOrganization()
    },
  },
  created() {
    this.resize()
    // 监听屏幕变化
    window.addEventListener('resize', e => {
      this.resize(e)
    })
    this.initOrganization()
  },
  methods: {
    resize(e) {
      let width = e ? e.target.innerWidth : window.innerWidth
      if (!width) return (this.isSmallScreen = false)
      this.isSmallScreen = width < 1276 ? true : false
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },

    initOrganization() {
      const currentOrganizationId = getCurrentOrganizationId()
      let organizationName
      if (currentOrganizationId) {
        const targetItem = this.subsidiaryDropLists.find(item => item.organizationId === currentOrganizationId)
        organizationName = targetItem ? targetItem.organizationName : this.ORGANIZATION_NAME
      } else {
        organizationName = this.ORGANIZATION_NAME
      }
      this.selectedOrganization = organizationName
    },

    // 选择公司
    selectOrganization(item) {
      this.selectedOrganization = item.organizationName
      this.$store.dispatch('user/getPermissionCommunityList', {
        isFirst: true,
        organizationId: item.organizationId,
        reload: true,
      })
      setCurrentOrganizationId(item.organizationId)
      this.$store.dispatch('user/getSealConfig')
    },

    // 操作详情
    optionDetail(type) {
      if (type === 1) {
        // 导入导出记录
        this.$store.dispatch('tagsView/uprecordDraw', true)
      } else if (type === 2) {
        // 操作手册
        window.open('https://www.yuque.com/jingjue-willpower/oxbia9?#《物业帮帮用户指南》', '_blank')
      } else if (type === 3) {
        // 视频教程
        let pathInfo = this.$router.resolve({
          path: '/videoTutorials',
        })
        window.open(pathInfo.href, '_blank')
      } else if (type === 4) {
        // 安全中心
        this.$refs.SecurityCenter.drawer = true
      } else if (type === 5) {
        // 退出登录
        this.logout()
      } else if (type === 6) {
        // 发起审批
        this.$refs.InitiateApproval.drawer = true
      } else if (type === 7) {
        // 带我审批
        this.$refs.WaitingApproval.drawer = true
      }
    },
    async logout() {
      this.$store.dispatch('tagsView/delAllViews')
      await this.$store.dispatch('user/logout')
      this.$store.dispatch('permission/generateRoutesCut', 0)
      this.$router.push('/login')
    },
    // 通知详情
    goDetail() {
      this.indexThis.$refs.SystemNotification.adminMessageList(true)
      this.indexThis.$refs.SystemNotification.drawer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  width: 100%;
  height: 56px;
  overflow: hidden;
  position: relative;
  background: #1874cd;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .reload {
    height: 100%;
    line-height: 55px;
    float: left;
    margin-left: 16px;
    cursor: pointer;
  }
  .hamburger-container {
    line-height: 56px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }
  .notice {
    position: relative;
  }

  .notice-dot {
    position: absolute;
    left: 9px;
    top: 20px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ea0000;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 56px;
    padding-right: 24px;
    .item {
      color: #ffffff;
      font-size: 14px;

      cursor: default;
    }
    .mr-24 {
      margin-right: 24px;
    }
    .icon {
      width: 16px;
      height: 16px;
      vertical-align: text-bottom;
      margin-right: 4px;
    }
    .arrow {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }
  }
  .flexBet {
    display: flex;
    display: flex;
    justify-content: space-between;
  }
}
</style>
